<template>
  <InputComponent disabled :value="result" v-bind="$attrs" />
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { Evaluate } from '../utils'

export default {
  inject: ['injection'],
  props: {
    formula: String,
  },
  computed: {
    data() {
      return this.injection.data
    },
    result() {
      try {
        return Evaluate(this.formula, this.data) || 0
      } catch (err) {
        return '-'
      }
    },
  },
  components: {
    InputComponent,
  },
}
</script>
